import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createClientRoomOptionModel } from '#models/RoomOptionModel.js';

/**
 * Client-side RoomOption container for dependency injection.
 * Provides the Firestore-backed RoomOption model for resolving room options by id.
 */
export function createRoomOptionsContainer(firestore: FirestoreContainer) {
  const $roomOptions = createContainer('roomOptions').providedLazy('ClientRoomOption', () =>
    createClientRoomOptionModel(firestore),
  );
  return $roomOptions;
}

export type $RoomOptionsContainer = ReturnType<typeof createRoomOptionsContainer>;
export type RoomOptionsContainer = $RoomOptionsContainer['use'];
